export const TimelineNumberOfDaysReport = 5;
export const TimelineMinNumberOfDaysReport = 2;